export const Config = {
  API_NAME: '[APPLICATION_USED_API_NAME]',
  API_URL: '/api/',
  ENUM_SERVICE_API_VERSION: 'v1',
  USER_SERVICE_API_VERSION: 'v1',
};
